import { render, staticRenderFns } from "./ProductInvestment.vue?vue&type=template&id=baa3e2aa&scoped=true"
import script from "./ProductInvestment.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductInvestment.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductInvestment.vue?vue&type=style&index=0&id=baa3e2aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa3e2aa",
  null
  
)

export default component.exports